$(document).ready(function () {
  $(".banner-section .banner-list").slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    arrows: false,
    slidesToScroll: 1,
    adaptiveHeight: true
  });


   $(".summer-sale-inner").slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    arrows: false,
    slidesToScroll: 1,
    adaptiveHeight: true
  });

  
  
  $(".design-carousel-section .slider-blocks").slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  $("#testimonials-slider").slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  

  $(".customer-slider .customer-list").slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  $(".summer-customer-slider .customer-list").slick({
    dots: true,
    arrows: false,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  $(".products-slider .product-list").slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 641,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '40px'
        }
      }
    ]
  });

  $(".products-slider-new .product-list").slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '110px'
  });


$(".find_your_parfect_sc .product-lists").slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 641,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '40px'
        }
      }
    ]
  });




});



 









// popup

$(document).ready(function() {

  $('.sm_open').on('click', function(){
      var modal = $(this).attr('data-modal');
      var modaloverlaycolor = $(this).attr('data-overlay');
      var modaleffect = $(this).attr('data-effect');
      var modalheader = $(this).attr('data-header');
      var modalheadertype = $(this).attr('data-header-type');
      var modalcontent = $(this).attr('data-content');
      var modaliconside = $(this).attr('data-icons');
      var modalwrappercolor = $(this).attr('data-wrapper-color');
  
      $('#' + modal).addClass(modaloverlaycolor);
      $('#' + modal + ' .sm_content').addClass(modaleffect);
      $('#' + modal + ' .sm_content .sm_header').html(modalheader);
      $('#' + modal + ' .sm_content .sm_header').addClass(modalheadertype);
      $('#' + modal + ' .sm_content .sm_area_all').html(modalcontent);
      $('#' + modal + ' .sm_icon_menu').addClass(modaliconside);
      $('#' + modal + ' .sm_content').addClass(modalwrappercolor);
      $('#' + modal).fadeIn().css("display", "flex");
      setTimeout(function(){
          $('#'+modal + ' .sm_content').addClass('show');
      }, 400);        
  });
  
  $('.sm_close').on('click', function(){
      var $modal = $(this).parents('.slim_modal');
      closeModal($modal);  
  });
  
  $('.slim_modal').on('click', function(e) {
    if (e.target !== this)
      return;
      var $modal = $(this);
      closeModal($modal);
  });
  
  function closeModal($modal) {
      $modal.find('.sm_content').removeClass('show');
      setTimeout(function(){
          $modal.removeClass('red green tan none');
          $modal.find('.sm_content').removeClass('red green tan');
          $modal.find('.sm_icon_menu').removeClass('is_right is_left');
          $modal.find('.sm_header').removeClass('detached');
          $modal.fadeOut();
      }, 400);
  }
});